/**
 * @generated SignedSource<<712b2ecd218d4f0577d318c32f396c1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NewsTickerComponent_Query$variables = {};
export type NewsTickerComponent_Query$data = {
  readonly Viewer: {
    readonly Newsticker: {
      readonly ActiveNewsTickers: ReadonlyArray<{
        readonly forwardingUrl: string | null;
        readonly id: string;
        readonly text: string;
      }>;
    };
  };
};
export type NewsTickerComponent_Query = {
  response: NewsTickerComponent_Query$data;
  variables: NewsTickerComponent_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ViewerQueryType",
    "kind": "LinkedField",
    "name": "Viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NewstickerViewerSchema",
        "kind": "LinkedField",
        "name": "Newsticker",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewstickerMessage",
            "kind": "LinkedField",
            "name": "ActiveNewsTickers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forwardingUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewsTickerComponent_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NewsTickerComponent_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4b53c2717d487e3d97d1d4f710b4b5f3",
    "id": null,
    "metadata": {},
    "name": "NewsTickerComponent_Query",
    "operationKind": "query",
    "text": "query NewsTickerComponent_Query {\n  Viewer {\n    Newsticker {\n      ActiveNewsTickers {\n        id\n        text\n        forwardingUrl\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "84bb22e2c4da452c3ad964f94f29f6b5";

export default node;
